import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MasterDetailLayoutComponent } from 'src/app/shared/components/master-detail-layout/master-detail-layout.component';
import { PrinterFormService } from '../../services/printer-form.service';
import { GeneralSettingsFormService } from '../../services/general-settings-form.service';
import { PrintersModuleService } from '../../services/printers-module.service';
import { mobileCheck } from 'src/utilities';
import { PrintersListComponent } from "../printers-list/printers-list.component";
import { GeneralSettingsComponent } from '../general-settings/general-settings.component';
import { PrinterDetailsComponent } from '../printer-details/printer-details.component';
import { ToolbarEventsService } from 'src/app/core';
import { ToolbarLayoutService } from 'src/app/shared/services/toolbar-layout.service';
import { LocalLoaderService } from 'src/app/shared/services/local-loader.service';
import { NewPrinterFormService } from '../../services/new-printer-form.service';
import { LocalLoaderComponent } from 'src/app/shared/components/local-loader/local-loader.component';
import { UpgradeUiViewDirective } from 'src/ajs-to-angular';
import { PrinterOperationService } from '../../services/printer-operation.service';
import { PrinterNavigationStateService } from '../../services/printer-navigation-state.service';
import { $state } from 'app/ajs-upgraded-providers';
import { Transition } from 'angular-ui-router';

@Component({
  selector: 'app-settings-printers-module',
  standalone: true,
  imports: [
    CommonModule, UpgradeUiViewDirective,
    MasterDetailLayoutComponent,
    GeneralSettingsComponent,
    PrinterDetailsComponent,
    PrintersListComponent,
    LocalLoaderComponent,
  ],
  providers: [
    LocalLoaderService,
    PrinterFormService,
    NewPrinterFormService,
    GeneralSettingsFormService,
    PrintersModuleService,
    PrinterOperationService,
    PrinterNavigationStateService
  ],
  templateUrl: './settings-printers-module.component.html',
  styleUrl: './settings-printers-module.component.scss'
})
export class SettingsPrintersModuleComponent implements OnInit, OnDestroy {

  protected readonly printersModuleService = inject(PrintersModuleService);
  protected readonly localLoader = inject(LocalLoaderService);
  private readonly toolbarEventsService = inject(ToolbarEventsService);
  private readonly toolbarLayoutService = inject(ToolbarLayoutService);
  private readonly printerNavigationStateService = inject(PrinterNavigationStateService);
  private readonly state = inject($state);
  
  protected isEdit = false;
  private unsubscribeOnBefore: Function | undefined;

  protected isMobile = mobileCheck();

  constructor() {
    this.toolbarEventsService.moduleTitle.next("PRINTERS");

    // --- HOOK PREVENTIVO ---
    this.unsubscribeOnBefore = this.state.router.transitionService.onBefore(
      { from: 'app.new.settings.printers.**' }, 
      async (transition: Transition) => {
        // console.log("TRANSITION from ", transition.from().name, " to ", transition.to().name)
        // if (transition.to().name === transition.from().name) {
        //   return true;
        // }

        const params = transition.targetState().params();
        if(params.hasOwnProperty('checkPendingData') && !params.checkPendingData) return true;

        const confirmed = await this.printerNavigationStateService.checkPendingData();

        if (!confirmed) {

          return false; // Blocca la navigazione
        }

        // if (this.isMobile) {
        //   this.printersModuleService.updateShowDetailMobile(true);
        // }
        return true; // Nessuna modifica, procedi pure
      }
    );
  }

  async ngOnInit() {
    await this.loadData();
    if(!this.isMobile && (this.printersModuleService.selection()?.type === 'GENERAL' || !this.printersModuleService.selection())) {
      this.state.go('app.new.settings.printers.general');
    }
  }

  async loadData() {
    await this.printersModuleService.loadPrinterList();
  }

  ngOnDestroy(): void {
    if (this.unsubscribeOnBefore) {
      this.unsubscribeOnBefore();
    }
    this.toolbarLayoutService.showModuleTitle$.next(true);
  }
}